const riot = require('riot');

riot.tag2('module-template', '<div class="f fclm h-full"> <div class="f fm fbw mb18"> <div class="f fm pt2 text-label_high"><i class="icon-template fs20 mr6"></i> <div class="lh15 pb3">テンプレート</div> </div> <button class="button label_pale f fh s24 p0" onclick="{onCreateTemplate}"><i class="icon-add fs20"></i></button> </div> <div class="h-full overflow-y-scroll" ref="body"> <div class="mb12 mb0-last" data-is="item-template" each="{template, index in opts.templates}" template="{template}" onclick="{onTemplateEdit}"></div> </div> </div>', 'module-template,[data-is="module-template"]{display:block}', '', function(opts) {
    this.onTemplateEdit = (e) => {
      var record = e.item.template;

      var modal = spat.modal.open('modal-template-edit', {
        item: record,
      });

      modal.on('submit', async (e) => {
        await app.store.doc(record.path).update({
          title: e.data.title,
          project_ref: e.data.project ? e.data.project.ref : null,
          tags: e.data.tags,
          duration: e.data.duration,
        });
        await app.store.doc(record.path).refresh();
        var updatedTemplate = await app.store.doc(record.path).fetch({ relation: true });
        this.trigger('submit');
      });

      modal.on('delete', () => {
        app.store.doc(record.path).delete();
        this.opts.templates.splice(e.item.index, 1);
        this.update();
      });
    };

    this.onCreateTemplate = (e) => {
      var modal = spat.modal.open('modal-template-edit');

      modal.on('create', async (e) => {
        this.createTemplate({
          title: e.data.title,
          project_ref: e.data.project ? e.data.project.ref : null,
          tags: e.data.tags,
          duration: e.data.duration,
        });
      });
    };

    this.createTemplate = async ({ title, project_ref, tags, duration }) => {
      var ref = await app.store.collection(`users/${app.store.currentUser.id}/templates`).add({
        title,
        project_ref,
        tags: tags ? tags : [],
        duration: duration,
        created_user_ref: app.store.currentUser.ref,
        created_at: Date.now(),
        updated_at: Date.now(),
      });
      this.trigger('submit');
    };
});